module.exports = __webpack_public_path__ + "static/media/IMG_4569.12a7b6b3.jpg";